export default "__VITE_ASSET__226ea657__"